import { Pertanyaan } from "../types/Teleconsultation";

const STORAGE_KEY = "teleconsult_disclaimer";

export const getDisclaimer = (): Pertanyaan => {
  const saved = localStorage.getItem(STORAGE_KEY);

  if (!saved) {
    return {
      berat: "",
      tinggi: "",
      lamaSakit: "",
      minumObat: "",
      riwayatCovid: "",
    };
  }

  return JSON.parse(saved);
};

export const saveDisclaimer = (data: Pertanyaan) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const clearDisclaimer = () => {
  localStorage.removeItem("teleconsult_disclaimer");
};